export default {
  cookieTimeout: '1D',
  tableLimitOption: [25, 50, 100, 200, 500, 1000],
  tableLayout: ['prev', 'pager', 'next', 'sizer', 'jumper'],
};



// WEBPACK FOOTER //
// ./src/utils/js/constant.js